import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteAbstractCoursesOperation = async (
  abstractCourseId: number,
  setDeleteAbstractId: (abstractCourseId: number | null) => any,
) => {
  try {
    setDeleteAbstractId(abstractCourseId);

    const res = await appApi.deleteAbstractCourse(abstractCourseId);
    if (res.data.ok) {
      await globalSettingsStores.fetchSetting();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }
    setDeleteAbstractId(null);
  } catch (e) {
    setDeleteAbstractId(null);
    console.error(
      `deleteAbstractCoursesOperation is failed with the abstractCourseId: ${abstractCourseId}, and the error: ${e}`,
    );
    toast.error(`משהו קרה, נסה שוב בעוד מספר רגעים...`);
  }
};
